// extracted by mini-css-extract-plugin
module.exports = {"content_padding":"ConfirmArchiveDialog_content_padding__2HDlF","rows":"ConfirmArchiveDialog_rows__1Sk-s"};